var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useCallback } from "react";
import { useMutation, useQuery } from "react-query";
import { CouponsApi } from "../../services";
export const useProviderCodes = (countryCode) => {
    const fetchProviderCodes = () => __awaiter(void 0, void 0, void 0, function* () {
        const response = yield CouponsApi.init().getProviders(countryCode);
        return response.data.map((provider) => provider.code);
    });
    const queryResult = useQuery(["providerCodes", countryCode], fetchProviderCodes, {
        retry: false,
        refetchOnWindowFocus: false,
    });
    return {
        providerCodes: queryResult.data,
        isProviderCodesLoading: queryResult.isLoading,
        isProviderCodesError: queryResult.isError,
        providerCodesError: queryResult.error,
    };
};
export const useRequestCoupon = () => {
    const requestCouponMutation = useMutation((code) => __awaiter(void 0, void 0, void 0, function* () {
        yield CouponsApi.init().requestCoupon(code);
    }));
    const requestCoupon = useCallback((code) => __awaiter(void 0, void 0, void 0, function* () {
        yield requestCouponMutation.mutateAsync(code);
    }), [requestCouponMutation]);
    return {
        requestCoupon,
        isRequestCouponLoading: requestCouponMutation.isLoading,
        isRequestCouponSuccess: requestCouponMutation.isSuccess,
    };
};
//# sourceMappingURL=useCoupons.js.map